module.exports = __webpack_public_path__ + "media/images/icon_list/ticket-ade6015793d9deefcf3c2740d24ef1c3.svg";